import angular from 'angular';

export const StripeElementDirective = ($window, $parse) => {
    'ngInject';
    return {
        restrict: 'A',
        scope: {
            tokenHandler: '&',
            complete: '=',
            style: '<'
        },
        link: ($scope, $element, attrs) => {
            const stripe = $window.stripe;
            const elements = stripe.elements();
            const style = $scope.style || {
                base: {
                  color: '#32325d',
                  lineHeight: '24px',
                  fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
                  fontSmoothing: 'antialiased',
                  fontSize: '16px',
                  '::placeholder': {
                    color: '#000000'
                  }
                },
                invalid: {
                  color: '#fa755a',
                  iconColor: '#fa755a'
                }
            };              
            const card = elements.create('card', {style: style});
            card.mount($element[0]);
            card.addEventListener('change', (event)  => {
                let displayError = document.getElementById(attrs.errorElement);
                if (event.error) {
                  displayError.textContent = event.error.message;
                } else {
                  displayError.textContent = '';
                }
                if (event.complete) {
                    $scope.$apply(() => {
                        $scope.complete = event.complete;
                    });
                }
            });
              
            const form = document.getElementById(attrs.parentForm);
            form.addEventListener('submit', (event) => {
                event.preventDefault();
                stripe.createToken(card).then((result) => {
                    if (result.error){
                        var errorElement = document.getElementById(attrs.errorElement);
                        errorElement.textContent = result.error.message;
                    } else {
                        $scope.$apply(() => {
                           $parse(tokenHandler)(scope);
                        })
                    }               
                });
            });

        }
    }
}


// WEBPACK FOOTER //
// ./src/app/directives/stripe-element.directive.js